import React, { useState, useEffect } from 'react';
import { Form, Modal, Button, Table, Row, Col } from 'react-bootstrap';
import { useProvider, Toast } from '../../context/MenuProvider';


const SincronizarProdutos = () => {
    const {
      crud,
    } = useProvider()
    const { get, del, post, loading } = crud || {};
    const [produtosMesclagem, setProdutosMesclagem] = useState([]);
    const [convites, setConvites] = useState([]);
    const [query, setQuery] = useState('');
    const [nextUrl, setNextUrl] = useState(null);
    const [show, setShow] = useState(false);
    const [item, setItem] = useState({});
    const [tableSelected, setTableSelected] = useState(null);
    
    
    const buscarConvite = async() => {
      try{
        const response = await get(
          '/gvendas/produtos-convite-mesclagem/?expand=origem,destino&ordering=data&is_ativo=true',
          'pagina'
        );
        if (response){
          setConvites(response[0].results);
        }
      }catch(err){
        
      }finally{
        
      }
    }
    
    const pesquisarMesclagem = (convite, item, is_origem) => {
      setShow(true);
      setItem({convite, item, is_origem});
    }
    
    useEffect(()=>{
      buscarProdutosSincronizacao(true);
    }, [query, convites])
    
    const buscarProdutosSincronizacao = async (novaBusca = false) => {
        let url = `/gvendas/produtos-mesclagem/?ordering=emissor__nome_do_produto&expand=emissor,receptor`;

        if (query) url += `&search=${query}`;
        
        if (novaBusca) {
            setProdutosMesclagem([]);
            setNextUrl(null);
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (loading || !url) return;
        try {
            const response = await get(url,'pagina');
            if (response) {
                const novosItens = response[0].results;
                setProdutosMesclagem((itensAnteriores) => novaBusca ? novosItens : [...itensAnteriores, ...novosItens]);
                setNextUrl(response[0].next);
            }
        } catch (err) {

        } finally {
            
        }
    };

    
    useEffect(()=>{
      buscarConvite();
    },[])
    
        // Detecta o fim da página para carregar mais clientes
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarProdutosSincronizacao();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    const deleteRow = async (itemParaRemover) => {
      try{
        await del(`/gvendas/produtos-mesclagem/${itemParaRemover.id}/`);
        const novaLista = produtosMesclagem.filter(item => item !== itemParaRemover);
        setProdutosMesclagem(novaLista);
      }catch(err){
        
      }
    }
    const adicionarRow = async () => {
      try{
        const data = {
          convite:convites[0]?.id
        }
        const response = await post(data, `/gvendas/produtos-mesclagem/`);
        if(response){
          buscarProdutosSincronizacao(true);
        }
      }catch(err){
        //alert(JSON.stringify(err.response))
      }
    }

    
    return (
        <>
          <CentralModal crud={crud} item={item} show={show} setShow={setShow} setProdutosMesclagem={setProdutosMesclagem}/>
          <div className="">
            <Form>
              <Form.Group controlId="formBasicSearch">
                <div className="input-group">
                  <Button variant="secondary" onClick={() => adicionarRow()}>
                    <i className="bi bi-plus"></i> Nova Linha
                  </Button>
                  <Form.Control 
                    type="text" 
                    placeholder="Digite o nome do produto" 
                    value={query} 
                    onChange={(e) => setQuery(e.target.value)} 
                    />
                      <Button variant="secondary" onClick={() => buscarProdutosSincronizacao(true)}>
                        <i className="bi bi-search"></i>
                      </Button>
                </div>
              </Form.Group>
            </Form>
            
            {convites.length >0 ?(<>
            {convites.map((convite, index) => (
              <div className="table-responsive my-3">
                <Table className="table table-bordered w-100">
                  <thead className="table-dark">
                      <tr>
                        <th>Atualização</th>
                        <th>{convite?.origem?.nome_da_loja}</th>
                        <th></th>
                        <th>{convite?.destino?.nome_da_loja}</th>
                        <th></th>
                      </tr>
                  </thead>
                  <tbody>
                    {produtosMesclagem.length<=0 && (
                      <tr>
                        <td colspan="4" className="text-center text-muted">Nenhum produto encontrado</td>
                      </tr>
                    )}
                    {produtosMesclagem.map((item, index) => (
                      <tr onClick={()=>setTableSelected(index)} className={tableSelected === index?'table-secondary':''}>
                        <td>{item.data_atualizacao_mesclagem.split('T')[0].split('-').reverse().join('/')}</td>
                        <td onClick={()=>pesquisarMesclagem(convite, item, true)}><i class="bi bi-pencil-square text-muted"></i> {item?.emissor?.nome_do_produto}</td>
                        <th>{item.emissor && item.receptor ?(<i className="bi bi-link"></i>):(<></>)}</th>
                        <td onClick={()=>pesquisarMesclagem(convite, item, false)}><i class="bi bi-pencil-square text-muted"></i> {item?.receptor?.nome_do_produto}</td>
                        <td>
                          <Button variant="danger" className="btn-sm" onClick={() => deleteRow(item)}>
                            <i className="bi bi-trash"></i>
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ))}
            </>):(<></>)}
        </div>
      </>
    );
};


const CentralModal = ({crud, item, show, setShow, setProdutosMesclagem}) => {
  const [produtos, setProdutos] = useState([]);
  const [mesclagem, setMesclagem] = useState(null);
  const [tableSelected, setTableSelected] = useState(null);
  const [query, setQuery] = useState('');
  const [nextUrl, setNextUrl] = useState(null);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true); 
  const { get, del, post, patch, loading } = crud;
  
  const handleSalvar = async() => {
    try{
      const data = {
        convite:mesclagem?.convite?.id||mesclagem?.convite,
        emissor: mesclagem?.emissor?.id || mesclagem?.emissor,
        receptor: mesclagem?.receptor?.id || mesclagem?.receptor
      }
      const requestApi = mesclagem?.id?patch:post;
      const response = await requestApi(data, `/gvendas/produtos-mesclagem/${mesclagem?.id?mesclagem.id+"/":''}?expand=receptor,emissor`);
      if(response){
        setProdutosMesclagem((prevItems) =>
          prevItems.map((item) =>
            item.id === response[0].id ? response[0] : item
          )
        );
        setShow(false);
      }
    }catch(err){
      //alert(JSON.stringify(err.response))
    }
  }
  
  useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarProdutos();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
  }, [loading, nextUrl]);
  
  
  const buscarProdutos = async (novaBusca = false) => {
        
        let url = `/gvendas/produtos/mesclagem/${getEmpresa(item?.is_origem)?.id}/${item?.convite?.id}/?expand=emissor,receptor&is_ativo=true&tipo=agenda&ordering=nome_do_produto&limit=10`;

        if (query) url += `&search=${query}`;
        
        if (novaBusca) {
            setProdutos([]);
            setNextUrl(null);
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }
        if (loading || !url) return;
        
        try {
            const response = await get(url,'pagina');
            if (response) {
                const novosItens = response[0].results;
                setProdutos((itensAnteriores) => novaBusca ? novosItens : [...itensAnteriores, ...novosItens]);
                setNextUrl(response[0].next);
            }
        } catch (err) {
          
        } finally {
            
        }
  };
  
  const getEmpresa = (to_origem) => {
    return {
        id:to_origem?(item?.convite?.origem?.id):(item?.convite?.destino?.id),
        nome:to_origem?(item?.convite?.origem?.nome_da_loja):(item?.convite?.destino?.nome_da_loja),
      };
  }
  
  
  const getProduto = (to_origem) => {
    return {
        id:to_origem?(mesclagem?.emissor):(mesclagem?.receptor),
        nome:to_origem?(mesclagem?.emissor?.nome_do_produto):(mesclagem?.receptor?.nome_do_produto),
      };
  }
  
  
  useEffect(()=>{
    setTableSelected(null);
    setMesclagem(null);
    if(item?.convite?.id && show){
      setMesclagem(item?.item);
      buscarProdutos(true);
    }
  },[item?.convite?.id, show, query])


  return (
    <div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Sincronizar Produto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="formDiaDoAniversario" className="mt-3">
            <Form.Label>{getEmpresa(item?.is_origem).nome}</Form.Label>
            <Form.Control 
              type="text" 
              readOnly={true}
              value={getProduto(item?.is_origem)?.nome} 
              />
          </Form.Group>
          <Form.Group controlId="formDiaDoAniversario" className="mt-3">
            <Form.Label>{getEmpresa(!item?.is_origem).nome}</Form.Label>
            <Form.Control 
              type="text" 
              readOnly={true}
              value={getProduto(!item?.is_origem)?.nome} 
              />
          </Form.Group>
          <div className="input-group pt-5">
            <Button variant="secondary" onClick={handleSalvar}>
              Salvar
            </Button>
            <Form.Control 
              type="text" 
              placeholder="Digite o nome do produto" 
              value={query} 
              onChange={(e) => setQuery(e.target.value)} 
            />
            <Button variant="secondary" onClick={() => buscarProdutos(true)}>
              <i className="bi bi-search"></i>
            </Button>
          </div>

          <div className="table-responsive my-3">
            <Table className="table table-bordered w-100">
              <thead className="table-dark">
                <tr>
                  <th className="text-center">#</th>
                  <th>{getEmpresa(item?.is_origem).nome}</th>
                </tr>
              </thead>
              <tbody>
              {produtos.length<=0 && (
                <tr>
                  <td colspan="2" className="text-center text-muted">Nenhum produto encontrado</td>
                </tr>
              )}
              {produtos.map((produto, index) => (
                <tr onClick={()=>{
                  setTableSelected(index);
                  setMesclagem((prevItem) => ({
                    ...prevItem,
                    [!item?.is_origem ? "receptor" : "emissor"]: produto.id,
                    [!item?.is_origem ? "para" : "de"]: produto.nome_do_produto,
                  }));
                }} className={tableSelected === index?'table-secondary':''}>
                  <th className="text-center">{produto.is_sincronizado?(<i className="bi bi-link"></i>):(<></>)}</th>
                  <td>{produto.nome_do_produto}</td>
                </tr>
              ))}
              </tbody>
            </Table>
          </div>
          {nextUrl && !loading && (
            <Button variant="secondary" onClick={() => buscarProdutos(false)} className="mt-2  w-100">
              Buscar mais...
            </Button>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="btn-sm" onClick={handleClose}>
            Fechar
          </Button>
          <Button variant="primary" className="px-5" onClick={handleSalvar}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};


export default SincronizarProdutos;